document.addEventListener("DOMContentLoaded", function (event) {
  var trackFilterEvent = function (filters) {
    var name = document.querySelector("section[data-collection-name]").dataset
      .collectionName;

    if (window.CustomTracking) {
      window.CustomTracking.trackProductListFiltered(name, filters);
    }
  };

  var closeDrawer = function () {
    var drawer = $(".filters__drawer");
    drawer.removeClass("is-open");
  };

  var fetchData = function (params, shouldClose) {
    var url =
      window.location.pathname + (params ? "?" + params.toString() : "");

    if ("history" in window) {
      history.pushState({}, "", url);
    }

    var container = document.querySelector(".collection-main");
    var loader = $(".loading-overlay", container);
    loader.addClass("is-open");

    window.magicForceReplaceAll(container, url, function () {
      loader.removeClass("is-open");
      if (shouldClose) {
        closeDrawer();
      }
    });
  };

  $(".filters__section").each(function () {
    var items = $(this).find("li");
    if (items.length === 0) {
      $(this).hide();
    }
  });

  $(".filters").on("click", ".filters__btn", function (e) {
    var drawer = $(".filters__drawer");
    drawer.css("display", "");

    setTimeout(function () {
      drawer.addClass("is-open");
      e.stopPropagation();
    }, 10);
  });

  $(".filters").on("click", ".filters__reset-action-btn", function () {
    fetchData(null, true);
  });

  $(".filters__close-btn").click(function () {
    var drawer = $(".filters__drawer");
    drawer.removeClass("is-open");
  });

  $(".filters__section-btn").click(function () {
    $(this).parent().toggleClass("is-open");
  });

  $(".filters__reset-btn").click(function () {
    fetchData(null, false);
  });

  $(".filters__apply-btn").click(function () {
    var checkboxes = $(".filters__checkbox:checked");
    var params = new URLSearchParams();
    var filters = [];

    checkboxes.each(function () {
      var cb = $(this);
      var name = cb.attr("name");
      var value = cb.val();
      params.append(name, value);
      filters.push({
        type: name,
        value: value,
      });
    });

    fetchData(params, true);
    trackFilterEvent(filters);
  });

  $(document).on("keyup", function (e) {
    if (e.key == "Escape") {
      closeDrawer();
    }
  });

  $(".filters__drawer").click(function (e) {
    e.stopPropagation();
  });

  $(document).click(function () {
    if ($(".filters__drawer").hasClass("is-open")) {
      closeDrawer();
    }
  });
});
